import React from 'react';
import PropTypes from 'prop-types';

import MatchSheetV2 from './MatchSheet';
import OrderOfPlayV2 from './OrderOfPlayV2';

import { drawScheduleTypeIds } from '../../../../../utils/eventConstants';
import NextAvailableSchedule from './NextAvailableSchedule';

const ScheduleTabContentV2 = (props) => {
    const { scheduleTypeId } = props;

    if (scheduleTypeId === drawScheduleTypeIds.ORDER_OF_PLAY) {
        return <OrderOfPlayV2 />;
    }

    if (scheduleTypeId === drawScheduleTypeIds.MATCH_SHEET) {
        return <MatchSheetV2 />;
    }

    if (scheduleTypeId === drawScheduleTypeIds.NEXT_AVAILABLE) {
        return <NextAvailableSchedule />;
    }

    return null;
};

ScheduleTabContentV2.propTypes = {
    scheduleTypeId: PropTypes.number.isRequired,
};

export default ScheduleTabContentV2;
